const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';
const TOTP_CODE = 'totpCode'
const TOTP_CODE_DATE = 'totpCodeDate'

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const getTotpCode = () =>
{
    const totpCodeCreatedAt = localStorage.getItem(TOTP_CODE_DATE);
    if (totpCodeCreatedAt === null) {
        localStorage.removeItem(TOTP_CODE);
    }
    // get total seconds between the times
    const timePassed = Math.abs(Date.now() - totpCodeCreatedAt) / 1000;
    // calculate (and subtract) whole days
    const diffDays = Math.floor(timePassed / 86400);
    if (diffDays > 0) {
        localStorage.removeItem(TOTP_CODE);
        localStorage.removeItem(TOTP_CODE_DATE);
    }
    return localStorage.getItem(TOTP_CODE);
}

const setToken = token => localStorage.setItem(TOKEN_KEY, token);
const setRefreshToken = refreshToken => localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
const setTotpCode = totpCode => localStorage.setItem(TOTP_CODE, totpCode);
const setTotpCodeDate =() => localStorage.setItem(TOTP_CODE_DATE, Date.now());

export const setTokens = ({
    token,
    refresh_token,
}) => {
    setToken(token);
    setRefreshToken(refresh_token);
};

export const setAuthTotpCode = ({
   totpCode
}) => {
    setTotpCode(totpCode);
    setTotpCodeDate();
};

export const clearTokens = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(TOTP_CODE);
    localStorage.removeItem(TOTP_CODE_DATE);
};
